export default function BrandPromise() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: '正品保障',
      desc: '每一件商品均来自品牌官方授权渠道，支持专柜验货，100%正品承诺。',
    },
    {
      icon: 'ri-global-line',
      title: '全球直采',
      desc: '遍布欧洲与美国的专业买手团队，为您甄选全球顶尖品牌最新好物。',
    },
    {
      icon: 'ri-truck-line',
      title: '跨境速达',
      desc: '与DHL、FedEx等国际物流深度合作，海外直邮7-15个工作日送达。',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '专属服务',
      desc: '一对一顾问式服务，从选购到售后，全程为您提供专业建议与支持。',
    },
  ];

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="text-center mb-10">
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
          品牌承诺
        </h2>
        <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
          四大核心保障，让您每一次购物都安心无忧
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {features.map((f, i) => (
          <div key={i} className="text-center p-6 rounded-lg bg-background-50 border border-background-200/70">
            <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-accent-100 flex items-center justify-center">
              <i className={`${f.icon} text-xl text-accent-600`}></i>
            </div>
            <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">{f.title}</h3>
            <p className="text-xs text-foreground-500 leading-relaxed">{f.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}